export const getColumns = (id='') => window.axios.post(`home/getColumns?id=${id}`)
export const getBanner = () => window.axios.post('home/getBanner')
export const getDonation = () => window.axios.post('home/getDonation')
export const getStory = () => window.axios.post('home/getStory')
export const getPartners = () => window.axios.post('home/getPartners')
